export default __webpack_public_path__ + "static/media/OGUndead.97f6a104.webp";